import { DrawerProps } from 'antd';
import styled, { DefaultTheme } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

const PRESETS = {
  maxHeight: 95,
};

export const getStyles = (theme: DefaultTheme): { drawer: DrawerProps['styles'] } => ({
  drawer: {
    wrapper: {
      maxHeight: `${PRESETS.maxHeight}%`,
    },
    content: {
      borderTopLeftRadius: utils.rem(theme.Border.Radius.Large),
      borderTopRightRadius: theme.Border.Radius.Large,
    },
    body: {
      padding: 0,
    },
    header: {
      borderBottomColor: theme.Color.Neutrals.Border,
      padding: utils.rem(theme.Spacing.Size.MediumSmall),
    },
    footer: { borderTopColor: theme.Color.Neutrals.Border },
  },
});

export const BottomSheetCloseBar = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: center;
    padding-bottom: ${utils.rem(theme.Spacing.Size.MediumSmall)};
    & div {
      height: ${utils.rem(theme.Spacing.Size.XXSmall)};
      width: ${utils.rem(theme.Spacing.Size.MediumLarge)};
      background-color: ${theme.Color.Neutrals.Border};
      border-radius: ${utils.rem(theme.Border.Radius.Small)};
    }
  `}
`;
export const StyledCloseIconContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => utils.rem(theme.Spacing.Size.Medium)};
  right: ${({ theme }) => utils.rem(theme.Spacing.Size.Medium)};
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Modal};
  cursor: pointer;
`;
export const StyledCloseIconWrapper = styled.div`
  position: relative;
`;
